import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  addIconButton: {
    '&.MuiIconButton-root': {
      borderRadius: theme.spacing(0),
      padding: theme.spacing(0),
      justifyContent: 'flex-start',
    },
  },
  addIconLabel: {
    marginLeft: theme.spacing(1),
    '&.MuiTypography-body1': {
      fontSize: '14px',
    },
    color: theme.palette.select.light,
  },
  addIcon: {
    '&.MuiSvgIcon-root': {
      color: theme.palette.select.light,
      width: '20px',
      height: '20px',
      userSelect: 'none',
      fill: 'currentColor',
      fontSize: '1.5rem',
      flexShrink: 0,
    },
  },
  disabledButton: {
    '&.MuiSvgIcon-root': {
      opacity: 0.5,
    },
    '&.MuiTypography-body1': {
      opacity: 0.5,
    },
  },
}))
